export default __webpack_public_path__ + "static/media/spikes_4.fcf8dc1c.svg";